import locale from "@/helpers/locale";
import { json2csv_fn } from "@/utils/common";
import tranfResData from "@/utils/tranfResData";
import moment from "moment";
import _ from "lodash";
import { getExportName_fn } from '@/utils/common'
import { weekLocaleArray } from "@/utils/common";


function parserHeaderObj(targetObj) {
  let _resultObj = {};
  const _obj = tranfResData(targetObj);

  _obj.forEach(_head => {
    if (!_head.subItems) {
      _resultObj[_head.prop] = _head.label;
    } else {
      _head.subItems.forEach(_sub1 => {
        if (!_sub1.subChildItems) {
          _resultObj[`${_head.prop}.${_sub1.prop}`] = `${_head.label} > ${_sub1.label}`;
        } else {
          _sub1.subChildItems.forEach(_sub2 => {
            _resultObj[`${_head.prop}.${_sub1.prop}.${_sub2.prop}`] =
            `${typeof _head.label === "object" ? _head.label.join(" ") : _head.label} > ${_sub1.label} > ${_sub2.label}`;
          });
        }
      });
    }
  });

  return _resultObj;
}

export function parseSameHeaderObj(targetObj) {
  let _resultObj = {};
  const _obj = tranfResData(targetObj);
  _obj.forEach((item, idx) => {
    if(_resultObj.hasOwnProperty(item.prop)) {
      _resultObj[item.prop + "Refund" + (idx + 1)] = item.label;
    } else {
      _resultObj[item.prop] = item.label;
    }
  });
  return _resultObj;
}

function formatData(data) {
  let _data = _.values(data);
  _data.forEach((item, idx) => {
    if(item && typeof item === "object") {
      Object.keys(item).forEach((one, idx) => {
        item[one] = typeof item[one] === "object" ? Object.values(item[one]) : item[one];
      });
      _data[idx] = _.flattenDepth(Object.values(_data[idx]));
    }
  });
  return _.flattenDepth(_data);
}



export function exportCSV_fn(cinemaName, dataObj, date) {
  console.log(dataObj)
  // const ticketTableHeader = parserHeaderObj(basicObj.ticketTableHeader);
  // const invitationTableHeader = parserHeaderObj(basicObj.invitationTableHeader);
  // const allHeaderObj = {
  //   ...ticketTableHeader,
  //   ...{ emptyColumn: "" },
  //   ...invitationTableHeader,
  // };
  let csvData = [];
  let _dataObj = JSON.parse(JSON.stringify(dataObj));
  // 添加动态header
  _dataObj.nextTicket.header.forEach(header => {
    if (header.type) {
      header.label[0] = `${header.label[0]} ${moment(date + 86400000).format("M/D")}~`;
    }
  });
  Object.keys(_dataObj).forEach(key => {
    if(key === "todayTicket" || key === "couponReceive") {
      _dataObj[key].header.forEach((item, idx) => {
        if(idx === 0) {
          item.push({ label: "", prop: "emptyColumn" });
        }
      });
    }
    if(key === "otherRevenue") {
      const keyArrs = [
        locale("dailyDetail.otherRevenue.accountsRecovery"),
        locale("dailyDetail.otherRevenue.otherCashRecovery"),
        locale("dailyDetail.otherRevenue.accountsPayment"),
        locale("dailyDetail.otherRevenue.otherCashPayment"),
        locale("dailyDetail.otherRevenue.salesAccounts"),
      ];
      _dataObj[key].header.forEach((item, idx) => {
        if(idx < _dataObj[key].header.length - 1) {
          item.push({ label: "", prop: "emptyColumn" });
        }
        item.forEach(header => {
          header.label = header.label ? `${keyArrs[idx]} > ${header.label}` : "";
        });
      });
    }
    let formatHeader = _dataObj[key].isSame ? parseSameHeaderObj(_.flattenDepth(_dataObj[key].header))
      : parserHeaderObj(_.flattenDepth(_dataObj[key].header));
    _dataObj[key].data.unshift(formatHeader);
    _dataObj[key].data.forEach((table, idx) => {
      if (_dataObj[key].pos && idx > 0) {
        let _arr = formatData(table);
        _arr.splice(_dataObj[key].pos,0, "");
        csvData.push(_arr);
      } else {
        csvData.push(formatData(table));
      }
    });
    csvData.push([ "" ]);
  });

  json2csv_fn(csvData, [], 
  // moment().format("YYYYMMDDHHmm") + "_" + locale("sideMenu.reports.businessDailyDetail")
  getExportName_fn(
    locale("sideMenu.reports.businessDailyDetail"),
    '',
    '',
    '',
    moment(date).format('YYYY-MM-DD'),
    cinemaName,
    moment().format('YYYYMMDDHHmm')
  )
  );
}